import React from 'react'
import MainStep from './components/MainStep'
import Step from './components/Step'

import styles from './styles/check_algorithm_component.module.scss'


const CheckAlgorithmComponent = ({ title, description, contact, steps }) => {
  return (
    <section className={styles.check_algorithm_component}>
      <MainStep title={title} description={description} contact={contact} />
      {
        steps.map((item) => (
          <Step key={item.id} {...item} />
        ))}
    </section>
  )
}

export default CheckAlgorithmComponent